import QuotesList from "./QuotesList";
export default function AllQuotes() { return <QuotesList scope="all" />; }
